import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=3ba32768"
import script from "./pic.vue?vue&type=script&lang=js"
export * from "./pic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports